import {Component, inject, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {Client} from '../../../../../../api/client';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {environment} from '../../../../../environments/environment';
import {RecaptchaComponent, RecaptchaModule} from 'ng-recaptcha';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-client-modal',
  imports: [
    MatDialogContent,
    ReactiveFormsModule,
    RecaptchaModule,
  ],
  templateUrl: './client-modal.component.html',
  styleUrl: './client-modal.component.scss'
})
export class ClientModalComponent {
  private client = inject(Client)
  messageForm = new FormGroup({
    emailPhone: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    comment: new FormControl('', Validators.required),
    captcha: new FormControl('', [Validators.required]),
  });
  private notification = inject(NzMessageService)
  protected publicKey = environment.reCAPTCHA.PublicKey;
  @ViewChild('captchaRef')
  reCaptcha: RecaptchaComponent;


  constructor(
    public dialogRef: MatDialogRef<ClientModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  close() {
    this.dialogRef.close();
  }

  sendMessage() {
    if (this.messageForm.invalid) return
    this.client.contactUs_Add(this.messageForm.value).subscribe({
      next: () => {
        this.close();
        this.messageForm.reset();
        this.notification.success(`Ваше сообщение успешно доставлено!`)
      },
      error: (error) => {
        console.error(error);
      }
    })
  }

  resolved(captchaResponse: string) {
    this.messageForm.controls['captcha'].setValue(captchaResponse);
  }
}
